export class ServiceMapperError extends Error {
    constructor(message: string = "Failed to map service") {
        super(message);
        this.name = "ServiceMapperError";
    }
}